<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
    name: 'App',
	created() {
		this.getClientWidth();
		this.getBrowser();
	},
	mounted() {
		console.log(location.href)
	},
	methods: {
		// 获取当前设备宽度
		getClientWidth() {
			if (document.body.clientWidth > 1200) {
				document.documentElement.style.fontSize = '50px';
				this.$store.commit(
					'page/setClientWidth',
					document.body.clientWidth
				);
				return;
			}

			var deviceWidth =
				document.documentElement.clientWidth || window.innerWidth;
			if (deviceWidth >= 750) {
				deviceWidth = 750;
			}
			if (deviceWidth <= 320) {
				deviceWidth = 320;
			}
			document.documentElement.style.fontSize = deviceWidth / 7.5 + 'px';
			this.$store.commit(
				'page/setClientWidth',
				document.body.clientWidth
			);
		},
		// 获取浏览器信息
		getBrowser() {
			this.$store.commit('page/getBrowser');
		},
	},
};
</script>

<style lang="less">
@import '~@/assets/style/reset.less';
@import '~@/assets/style/index.less';

#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	height: 100%;
	width: 100%;
}
body,
html {
	margin: 0;
	padding: 0;
	width: 100%;
	height: 100%;
}
</style>
